import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { presentationMembershipOptions } from '@/module/Nomen/PresentationMembership/model/PresentationMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type PresentationMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function PresentationMembershipSelectControl<T extends FieldValues>(
  props: PresentationMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(presentationMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
